import React from 'react';
import { ArrowLeft } from 'lucide-react';

export const fieldClass =
  'mt-1.5 w-full h-11 rounded-xl bg-muted/60 px-3 text-sm text-[#0F172A] focus:outline-none focus:ring-2 focus:ring-primary/40';

export function StatusDot({ status, className = '' }) {
  const colour =
    status === 'overdue' ? 'bg-[#D64545]' : status === 'out' ? 'bg-[#E0A415]' : 'bg-[#2E9E6B]';
  const label = status === 'overdue' ? 'overdue' : status === 'out' ? 'out' : 'in';
  return (
    <span
      className={`inline-block h-2 w-2 rounded-full ${colour} ${className}`}
      aria-label={label}
      title={label}
    />
  );
}

export function ToolHeader({ title, onBack, officer, onOfficer }) {
  return (
    <div className="bg-white px-4 pt-4 pb-3 flex items-center gap-3 border-b border-border/60">
      <button type="button" data-testid="daily-attendance-back" onClick={onBack} aria-label="Back">
        <ArrowLeft className="h-5 w-5 text-[#0F172A]" />
      </button>
      <span className="text-base font-bold text-[#0F172A] truncate flex-1">{title}</span>
      {onOfficer && (
        <button
          type="button"
          data-testid="duty-officer-pill"
          onClick={onOfficer}
          className="max-w-[42%] truncate rounded-full bg-primary/10 px-3 h-8 text-[11px] font-semibold text-primary"
        >
          {officer || 'On duty'}
        </button>
      )}
    </div>
  );
}

export function GlanceLine({ children }) {
  return <p className="text-sm text-muted-foreground mt-1">{children}</p>;
}
